import styled from "rn-css";
import { white } from "../../StyleHelpers";

export const Container = styled.View`
	flex-direction: row;
	align-items: center;
	width: 100%;
	gap: 1rem;
`;

export const LegalsButton = styled.View<{ disabled?: boolean }>`
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;

export const IconWrapper = styled.View<{ isNarrow?: boolean; isToggle?: boolean }>`
	width: ${({ isNarrow }) => (isNarrow ? "3rem" : "3.5rem")};
	height: ${({ isNarrow }) => (isNarrow ? "3rem" : "3.5rem")};
	margin-right: ${({ isNarrow, isToggle }) => (isNarrow && isToggle ? "60px" : 0)};
`;

export const LegalText = styled.Text<{ isNarrow?: boolean }>`
	color: ${white};
	font-size: ${({ isNarrow }) => (isNarrow ? "1.3125rem" : "1.5625rem")};
	font-weight: 500;
	line-height: ${({ isNarrow }) => (isNarrow ? "1.5625rem" : "1.75rem")};
`;
